import React, { FC } from "react";
import { C28RelatedArticlesProps } from "./../../generated-types";

const C28RelatedArticles: FC<C28RelatedArticlesProps> = () => {
	return (
		<section>C28RelatedArticles</section>
	);
};

export default C28RelatedArticles;
